import { render, staticRenderFns } from "./ManageHygieneManagementPlan.vue?vue&type=template&id=4b898e38&"
import script from "./ManageHygieneManagementPlan.vue?vue&type=script&lang=js&"
export * from "./ManageHygieneManagementPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports